import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productInfoDocumentLink',
    standalone: false
})
export class ProductInfoDocumentLinkPipe implements PipeTransform {

  transform(refNumber: string, language:string): string {

    if (language === 'it') {
      language = 'fr'
    }

    return refNumber?.replace('$language', language);
  }
}
